import React, { useState, useEffect, useRef } from 'react';
import './UserMenu.css';

function UserMenu({ currentUser, onLogout, onShowSearchHistory, onShowEditProfile, onShowFavorites }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (!currentUser) return null;

  const userInitial = currentUser.firstName ? currentUser.firstName.charAt(0).toUpperCase() : '👤';
  const userName = currentUser.firstName && currentUser.lastName 
    ? `${currentUser.firstName} ${currentUser.lastName}`
    : currentUser.username || 'User';

  return (
    <div className="user-menu-container" ref={dropdownRef}>
      <div className="user-info">
        <div 
          className="user-avatar" 
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          {userInitial}
        </div>
        <span className="user-name">{userName}</span>
      </div>
      {dropdownOpen && (
        <div className="user-dropdown">
          <div className="dropdown-item" onClick={() => { onShowEditProfile(); setDropdownOpen(false); }}>
            Edit Profile
          </div>
          <div className="dropdown-item" onClick={() => { onShowFavorites(); setDropdownOpen(false); }}>
            Favorites
          </div>
          <div className="dropdown-item" onClick={() => { onShowSearchHistory(); setDropdownOpen(false); }}>
            Recent Searches
          </div>
          <div className="dropdown-item" onClick={() => { onLogout(); setDropdownOpen(false); }}>
            Logout
          </div>
        </div>
      )}
    </div>
  );
}

export default UserMenu;

